"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const equationTypePredicates_1 = require("./equationTypePredicates");
exports.walkEquation = (logicTree, onElement) => {
    if (!logicTree) {
        return;
    }
    const { left, operator, right } = logicTree;
    if (equationTypePredicates_1.isEquation(left)) {
        exports.walkEquation(left, onElement);
    }
    else if (left) {
        onElement(left);
    }
    if (operator) {
        onElement(operator);
    }
    if (equationTypePredicates_1.isEquation(right)) {
        exports.walkEquation(right, onElement);
    }
    else if (right) {
        onElement(right);
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2Fsa0VxdWF0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2V2YWx1YXRvci9lcXVhdGlvbi93YWxrRXF1YXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxxRUFBc0Q7QUFFekMsUUFBQSxZQUFZLEdBQUcsQ0FDMUIsU0FBK0IsRUFDL0IsU0FBNkMsRUFDdkMsRUFBRTtJQUNSLElBQUksQ0FBQyxTQUFTLEVBQUU7UUFDZCxPQUFPO0tBQ1I7SUFDRCxNQUFNLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsR0FBRyxTQUFTLENBQUM7SUFDNUMsSUFBSSxtQ0FBVSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ3BCLG9CQUFZLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0tBQy9CO1NBQU0sSUFBSSxJQUFJLEVBQUU7UUFDZixTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDakI7SUFDRCxJQUFJLFFBQVEsRUFBRTtRQUNaLFNBQVMsQ0FBQyxRQUFRLENBQUMsQ0FBQztLQUNyQjtJQUNELElBQUksbUNBQVUsQ0FBQyxLQUFLLENBQUMsRUFBRTtRQUNyQixvQkFBWSxDQUFDLEtBQUssRUFBRSxTQUFTLENBQUMsQ0FBQztLQUNoQztTQUFNLElBQUksS0FBSyxFQUFFO1FBQ2hCLFNBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQztLQUNsQjtBQUNILENBQUMsQ0FBQyJ9